import React, { FC } from "react";

export const UploadIcon: FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M19 11C19 7.13 15.87 4 12 4C8.78 4 6.07 6.18 5.26 9.15C2.82 9.71 1 11.89 1 14.5C1 17.54 3.46 20 6.5 20C8.26 20 16.75 20 18.5 20C20.99 19.99 23 17.97 23 15.48C23 13.15 21.25 11.26 19 11Z"
      fill="url(#paint0_linear_271_14214)"
    />
    <path
      d="M19 11C19 7.13 15.87 4 12 4C8.78 4 6.07 6.18 5.26 9.15C2.82 9.71 1 11.89 1 14.5C1 17.54 3.46 20 6.5 20C8.26 20 16.75 20 18.5 20C20.99 19.99 23 17.97 23 15.48C23 13.15 21.25 11.26 19 11Z"
      fill="url(#paint1_linear_271_14214)"
    />
    <path
      d="M13 13V15C13 15.55 12.55 16 12 16C11.45 16 11 15.55 11 15V13H9.21003C8.76003 13 8.54003 12.46 8.86003 12.15L11.65 9.35996C11.85 9.15996 12.16 9.15996 12.36 9.35996L15.15 12.15C15.46 12.46 15.24 13 14.8 13H13Z"
      fill="#3C82FD"
    />
    <defs>
      <linearGradient
        id="paint0_linear_271_14214"
        x1="1"
        y1="19.75"
        x2="23"
        y2="3.75"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D5E6FF" />
        <stop offset="1" stopColor="#D5E6FF" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_271_14214"
        x1="1"
        y1="19.75"
        x2="23"
        y2="3.75"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D5E6FF" />
        <stop offset="1" stopColor="#D5E6FF" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);
